export const DEFAULT_POSTER_URL = "https://via.placeholder.com/300x400";
export const DEFAULT_SHOW = "Better Call Saul";
